
import http from "../../../../../core/utils/apis/skillApi";
const CourseSkillsService = {
  getAllCourses: () => http.get("/courses"),
  getAllSkills: () => http.get("/skills"),
  assignSkillsToCourse: (courseId, skillIds) =>
    http.post(`/course-skills/${courseId}/assign`, { skillIds }),
  getSkillsByCourse: (courseId) => http.get(`/course-skills/${courseId}`),
  removeSkillFromCourse: (courseId, skillId) =>
    http.delete(`/course-skills/${courseId}/remove-skill/${skillId}`),
  getCoursesWithSkills: () => http.get("/course-skills/courses-with-skills"),
};

export default CourseSkillsService;
